import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tipoPrazo", "link"]

  connect() {
    const input = this.element.querySelector("input[name='notificacao[tipo]']")
    if (input?.value) this.apply(input.value)
  }

  toggle(event) {
    this.apply(event.detail?.value || event.target?.value)
  }

  apply(tipo) {
    this.tipoPrazoTargets.forEach(el => el.classList.toggle("hidden", tipo !== "Prazo"))
    this.linkTargets.forEach(el => el.classList.toggle("hidden", tipo !== "Audiência" && tipo !== "Oitiva"))
  }
}
